<twc-tab-menu
  [menuItems]="searchTabs()"
  [menuStyle]="TabMenuStyle.RUNNER"
></twc-tab-menu>
<hr class="divider mt-0 mb-15" />
<form class="tracker-container" [formGroup]="form" (ngSubmit)="onSubmit()">
  @if (trackingMode() === TrackingMode.CUSTOMER_REF) {
    <mat-form-field appearance="outline" class="large-field mb-8">
      <input
        [errorStateMatcher]="errorStateMatcher"
        matInput
        formControlName="customerReference"
        placeholder="Enter customer unique reference"
      />
    </mat-form-field>
  }
  <mat-form-field
    appearance="outline"
    class="chip-field large-field chip-box-input"
  >
    <twc-chip-input
      formControlName="trackingNumbers"
      placeholder="Enter up to 50 tracking numbers, comma separated"
    ></twc-chip-input>
  </mat-form-field>

  <button
    class="track-button medium full-width"
    mat-flat-button
    color="primary"
    type="submit"
  >
    Track
  </button>
</form>
